import React from 'react'

import { ProgressDotsContainer, ProgressDot } from './ProgressDots-styled'

export default ({ activeIndex, length }) => {
  return (
    <ProgressDotsContainer>
      {[...Array(length)].map((item, index) => {
        const active = !!(index <= activeIndex)
        return <ProgressDot key={index} active={active} />
      })}
    </ProgressDotsContainer>
  )
}



// WEBPACK FOOTER //
// ./src/component/_presentational/ProgressDots/ProgressDots.jsx